<header class="app-page-header">
  <h1 class="title">
    <ng-content select="[pageTitle]"></ng-content>
  </h1>
  <div class="header-actions">
    <ng-content select="[headerBtns]"></ng-content>
  </div>
</header>
